module.exports = __webpack_public_path__ + "img/projeto_tecno.62c37cc2.gif";